<div class="row">
  <div class="col-sm-12 mx-auto">
    <div class="tab-pane fade show active">
      <div class="container-fluid">
        <div class="tab-pane fade in show active" id="MagazineTabPane" role="tabpanel">
          <div class="my-2 mt-5 mfl-o mf3-center mf-tittle mf-tittle">
            <span class="ml-2">Audience List</span>
          </div>
          <div class="jumbotron py-3">
            <table class="table table-hover magazinetable table-responsive">
              <thead>
                <tr>
                  <th style="width:8%">Media Kit Id</th>
                  <th style="width:8%">Statistics</th>
                  <th style="width:8%">Value</th>
                  <th style="width:8%">Is Active</th>
                  <th style="width:8%">Edit</th>
                  <th style="width:8%">Delete</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let audi of audience; let i = index">
                  <td style="width:8%">{{audi.mediaKitId}}</td>
                  <td style="width:8%">{{audi.audienceStatisticName}}</td>
                  <td style="width:8%">{{audi.value}} </td>
                  <td style="width:8%">{{audi.isActive}} </td>
                  <td style="width:8%;" class="tittle1"><a (click)="editAudienceClick(audi)"><mdb-icon fas icon="edit"></mdb-icon></a></td>
                  <td style="width:8%;" class="tittle1"><a><i class="far fa-trash-alt" (click)="deleteAudi(audi.audienceId)"></i></a></td>
                  </tr>
              </tbody>
            </table>
          </div>
          <div class="row pb-3">
            <div class="col-sm-12 text-center">
              <button type="button" mdbBtn size="md" class="btn btn-secondary1 secondary relative waves-light"
                (click)="addAudienceClick()" mdbWavesEffect>Add Audience
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>